import { Moment } from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { User } from 'api/models';
import { TimesheetEntryType } from 'api/timesheets';
import {
  Drawer,
  DrawerContent,
} from 'components/organisms/timesheets/common/drawer';
import { Categories } from 'components/pages/timesheet-settings/categories';
import { TimesheetWeeklyRow, TimesheetWeeklyRowTask } from '../../types';
import { Title } from '../title';
import { Content } from './content';

const renderDrawerTitle = (task: TimesheetWeeklyRowTask) => {
  switch (task.entryType) {
    case TimesheetEntryType.TaskEntry:
      return (
        <Title primaryTitle={task.name} secondaryTitle={task.project.name} />
      );
    case TimesheetEntryType.PhaseEntry:
      return (
        <Title
          primaryTitle={task.projectPhase.name}
          secondaryTitle={task.project.name}
        />
      );
    case TimesheetEntryType.ProjectEntry:
      return <Title primaryTitle={task.project.name} />;
    default:
      return (
        <Title
          primaryTitle={task.activityName}
          secondaryTitle={
            task.project ? (
              task.project.name
            ) : (
              <FormattedMessage id="timesheets.labels.non_project_activity" />
            )
          }
        />
      );
  }
};

interface Props {
  onClose: () => void;
  timesheet?: TimesheetWeeklyRow;
  startDate: Moment;
  selectedDay?: string;
  categories: Categories;
  user: User;
}
export const EntryDetailDrawer: FC<Props> = ({
  onClose,
  timesheet,
  startDate,
  selectedDay,
  categories,
  user,
}) => {
  return (
    <Drawer visible={timesheet != null} onClose={onClose} destroyOnClose>
      {timesheet != null ? (
        <DrawerContent>
          <DrawerContent.Title>
            {renderDrawerTitle(timesheet.task)}
          </DrawerContent.Title>
          <DrawerContent.Content>
            <Content
              timesheet={timesheet}
              startDate={startDate}
              selectedDay={selectedDay}
              categories={categories}
              user={user}
            />
          </DrawerContent.Content>
        </DrawerContent>
      ) : null}
    </Drawer>
  );
};
